import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/planning/PlanningWorkspace.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
